import React from 'react';
import { observer } from 'mobx-react-lite';
import { useDependencies } from '@servicetitan/react-ioc';
import { ServiceFinanceStore, IDetailField } from '../../../../stores/service-finance.store';
import { Stack } from '@servicetitan/design-system';
import styles from './review-page.less';
import { PlanCard } from '../select-plan/plan-card';
import { ReviewItem } from './review-item';

export const CoReviewPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    const coApplicantDetails: IDetailField[][] = store.getCoApplicantDetailsMobile();

    return (
        <React.Fragment>
            <Stack direction="column" justifyContent="flex-start" className="m-y-2 page-content">
                <Stack.Item>
                    <div className={styles.title}>Review Your Co-Applicant's Information</div>
                    <ReviewItem header="Co-Applicant Details" details={coApplicantDetails} />
                    <div className={styles.followingMessage}>
                        By clicking the Submit Button below, the dealer salesperson submitting this
                        credit application hereby represents and agrees that (1) the dealer
                        salesperson made the applicant(s) aware he or she was applying for credit,
                        (2) the applicant(s) have given their permission to share the information on
                        this credit application with Service Finance Company, (3) the information
                        submitted on the application is true and correct in all respects, (4) the
                        applicant(s) have authorized Service Finance Company to share the
                        information on this credit application with third parties as it deems
                        appropriate, including but not limited to consumer reporting agencies, (5)
                        the applicant(s) have acknowledged and agreed that the information necessary
                        to verify the applicant(s)’s identity will be collected and submitted to
                        Service Finance Company, and (6) that the dealer salesperson submitting the
                        credit application has delivered to the applicant all disclosures required
                        by applicable federal and state law
                    </div>
                </Stack.Item>
            </Stack>
        </React.Fragment>
    );
});
